import { Navigate, createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { ParcelLoader } from '../components/parcel-loader.js';
import { useAuth } from '../lib/auth.js';
import { isSupabaseConfigured } from '../lib/supabase.js';
import { resolvePostAuthDestination } from '../lib/workspaces.js';

export const Route = createFileRoute('/')({
  component: AuthLandingRoute,
});

function AuthLandingRoute() {
  const { session, loading } = useAuth();
  const [destination, setDestination] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (loading || !session) return;

    let active = true;

    async function resolveDestination() {
      try {
        if (!isSupabaseConfigured) {
          setDestination('/signup/workspace');
          return;
        }
        const nextDestination = await resolvePostAuthDestination();
        if (active) setDestination(nextDestination);
      } catch (err) {
        if (active) {
          setError(err instanceof Error ? err.message : 'Unable to load workspaces.');
        }
      }
    }

    void resolveDestination();

    return () => {
      active = false;
    };
  }, [loading, session]);

  if (loading) {
    return (
      <main className="grid min-h-svh place-items-center bg-background">
        <ParcelLoader />
      </main>
    );
  }

  if (!session) return <Navigate to="/signin" />;
  if (destination) return <Navigate to={destination} />;

  return (
    <main className="grid min-h-svh place-items-center bg-background p-6">
      {error ? (
        <div className="max-w-sm space-y-2 text-center">
          <p className="font-medium text-sm">Opening Parcel</p>
          <p className="text-muted-foreground text-sm">{error}</p>
        </div>
      ) : (
        <ParcelLoader />
      )}
    </main>
  );
}
